import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogActions from '@/components/_custom/DialogActions/DialogActions'
import styles from './confirmDeleteStaffRate.module.scss'
import { useMutation } from '@apollo/client'
import { Close, Delete } from '@mui/icons-material'
import { DELETE_SECTION_GROUP } from '@/modules/API/staff/staffRate'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeleteGroupProps {
    handleClose: () => void
    sectionGroupId: number
    daycareId: number
    refetchStaffRates: () => void
}

const ConfirmDeleteStaffRate: FunctionComponent<ValidDeleteGroupProps> = ({
    handleClose,
    sectionGroupId,
    daycareId,
    refetchStaffRates
}: ValidDeleteGroupProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneStaffRate] = useMutation(DELETE_SECTION_GROUP, {
        variables: {
            sectionGroupId: sectionGroupId,
            daycareId: daycareId
        },
        onCompleted: () => {
            showNotificationSuccess(t('staffRateDeleted'))

            refetchStaffRates()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedStaffRate'))
        }
    })

    return (
        <div>
            <p className={styles.Text}>{t('confirmDeleteStaffRateMessage')}</p>
            <DialogActions>
                <ButtonTextIcon
                    type={'custom'}
                    customText={t('yes')}
                    customIcon={<Delete />}
                    onClick={deleteOneStaffRate}
                    nowrap
                />
                <ButtonTextIcon
                    type={'custom'}
                    customText={t('no')}
                    customIcon={<Close />}
                    onClick={handleClose}
                    nowrap
                />
            </DialogActions>
        </div>
    )
}

export default ConfirmDeleteStaffRate
